import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CARTONS_FEATURE_KEY } from '../keys';
import { CartonsState } from '../reducers/cartons.reducer';

const selectState = createFeatureSelector<CartonsState>(CARTONS_FEATURE_KEY);

export const selectBoxes = createSelector(selectState, (state: CartonsState) => state.boxes);
export const selectStatus = createSelector(selectState, (state: CartonsState) => state.status);
export const selectPage = createSelector(selectState, (state: CartonsState) => state.page);
export const selectHasMore = createSelector(selectState, (state: CartonsState) => state.hasMore);
export const selectLoaded = createSelector(selectState, (state: CartonsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: CartonsState) => state.loading);
